import React, { Fragment, useEffect, useState, useRef } from 'react'
import { Row, Col, Card, Table, Badge, Dropdown, DropdownButton, ProgressBar } from 'react-bootstrap'
import { Link, useLocation, useHistory } from 'react-router-dom';
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes"
import Pagination from '@mui/material/Pagination'
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import * as constants from '../../../utils/Constants'
import { padding } from '@mui/system';
import { ToastContainer, toast } from 'react-toastify'

const ListCandidate = () => {
    const { state } = useLocation();
    const location = useLocation();
    // const [page, setPage] = React.useState(1);
    const [page, setPage] = useState(Number(location?.pageCallBack) > 1 ? Number(location?.pageCallBack) : 1);
    const [pageDetails, setPageDetails] = useState({})
    const [sortBy, setSortBy] = useState(location?.sortByCallBack)
    const [order, setOrder] = useState(location?.orderCallBack)
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
    const history = useHistory();
    const [searchItems, setSearchItems] = useState([])
    const [sorting, setSorting] = useState([])
    const [searchText, setSearchText] = useState(location?.searchCallBack)
    let candidateData = []
    const loggedInUser = JSON.parse(localStorage.getItem('user'))
    const [loginData, setLoginData] = useState({})
    const [jobCompanyName, setJobCompanyName] = useState([])


    const handleSorting = (key, event) => {
        setSorting({ key, value: event.target.value });
    };

    //popup filter 
    const openFilter2 = () => {
        document.getElementById('staticBackdrop').style.display = "none"
    }
    const openFilter = () => {
        document.getElementById('staticBackdrop').style.top = (document.getElementById('popupbox').getBoundingClientRect().y + 20) + 'px'
        document.getElementById('staticBackdrop').style.left = (document.getElementById('popupbox').getBoundingClientRect().x - 460) + 'px'
        document.getElementById('staticBackdrop').style.display = "block"
        if (openFilterClicked) {
            openFilter2();
            openFilterClicked = false;
        }
        else {
            openFilterClicked = true;
        }
    }
    var openFilterClicked = false;
    //  Filter Dropdown
    // const [filterData, setFilterData] = useState({})
    const [filterData, setFilterData] = useState({ ...state, ...location?.filterDataCallback })
    const [qualifications, setQualifications] = useState([])
    const [ctc, setCtc] = useState([])
    const [experience, setExperience] = useState([])
    const [readyToRelocate, setRTR] = useState([])
    const [progressList, setProgressList] = useState([])
    const [qualificationselectedOptions, setQualificationselectedOptions] = useState([]);
    const [jobPostId, setJobPostId] = useState([])
    const [jobTitle, setJobTitle] = useState([])
    const [agentUniqueId, setAgentUniqueId] = useState([])
    

    let existingQualification = [];

    const readyToRelocateOptions = () => {
        return ([
            { label: "Yes", value: "yes" },
            { label: "No", value: "no" },
            { label: "NA", value: "na" }
        ]
        )
    }
    const companyNameOptions = () => {
        // console.log(jobCompanyName)
        return (jobCompanyName?.map(keys => ({ label: keys.companyName, value: keys.companyName })))
    }
    const jobIdOptions = () => {
        return (jobPostId?.map(keys => ({ label: keys, value: keys })))
    }
    const agentCodeOptions = () => {
        return (agentUniqueId?.map(keys => ({ label: keys, value: keys })))
    }
    const jobTitleOptions = () => {
        // console.log(jobTitle)
        return (jobTitle?.map(keys => ({ label: keys, value: keys })))
    }
    const handleJobId = (value) => {
        const newLoginData = { ...loginData }
        let jobIdChange = new Array();
        if (value) {
            for (var i = 0; i < value.length; i++) {
                jobIdChange.push(value[i].value.toString());
            }
            newLoginData["jobPostId"] = jobIdChange
        }
        else {
            jobIdChange.length = 0;
            newLoginData["jobPostId"] = jobIdChange
        }
        setFilterData(newLoginData)
    }
    const handleAgentCode = (value) => {
        const newLoginData = { ...loginData }
        let agentCodeChange = new Array();
        if (value) {
            for (var i = 0; i < value.length; i++) {
                agentCodeChange.push(value[i].value.toString());
            }
            newLoginData["agentUniqueId"] = agentCodeChange
        }
        else {
            agentCodeChange.length = 0;
            newLoginData["agentUniqueId"] = agentCodeChange
        }
        setFilterData(newLoginData)
    }
    const handleJobTitle = (value) => {
        const newLoginData = { ...loginData }
        let jobTitleChange = new Array();
        if (value) {
            for (var i = 0; i < value.length; i++) {
                jobTitleChange.push(value[i].value.toString());
            }
            newLoginData["jobTitle"] = jobTitleChange
        }
        else {
            jobTitleChange.length = 0;
            newLoginData["jobTitle"] = jobTitleChange
        }
        setFilterData(newLoginData)
    }
    const handleCompanyName = (value) => {
        const newLoginData = { ...loginData }
        let companyNameChange = new Array();
        if (value) {
            for (var i = 0; i < value.length; i++) {
                companyNameChange.push(value[i].value.toString());
            }
            newLoginData["jobCompanyName"] = companyNameChange
        }
        else {
            companyNameChange.length = 0;
            newLoginData["jobCompanyName"] = companyNameChange
        }
        setFilterData(newLoginData)
    }
    const handleReadyToRelocate = (value) => {
        const newLoginData = { ...filterData }
        let readyToRelocateChange = new Array();
        if (value) {
            for (var i = 0; i < value.length; i++) {
                readyToRelocateChange.push(value[i].value.toString());
            }
            newLoginData["readyToRelocate"] = readyToRelocateChange
        }
        else {
            readyToRelocateChange.length = 0;
            newLoginData["readyToRelocate"] = readyToRelocateChange
        }
        setFilterData(newLoginData)
    }

    const qualificationOptions = () => {
        return (qualifications?.map(qual => ({ label: qual, value: qual })))
    }

    const handleQualifications = (value) => {
        const newLoginData = { ...filterData }
        let qualificationChange = new Array();
        if (value) {
            for (var i = 0; i < value.length; i++) {
                qualificationChange.push(value[i].value.toString());
            }
            newLoginData["qualification"] = qualificationChange
        }
        else {
            qualificationChange.length = 0;
            newLoginData["qualification"] = qualificationChange
        }
        setFilterData(newLoginData)
    }

    const statusOptions = () => {
        return (progressList?.map(keys => ({ label: keys, value: keys })))
    }
    const handleListStatus = (value) => {
        const newLoginData = { ...filterData }
        let progressListChange = new Array();
        if (value) {
            for (var i = 0; i < value.length; i++) {
                progressListChange.push(value[i].value.toString());
            }
            newLoginData["status"] = progressListChange
        }
        else {
            progressListChange.length = 0;
            newLoginData["status"] = progressListChange
        }
        setFilterData(newLoginData)
    }
    const clearFilter = () => {
        window.location.reload()
    }

    const handlePageChange = (event, value) => {
        setPage(value);
        getListCandidate(value - 1, searchText, sortBy, order)
    }

    useEffect(() => {
        window.scrollTo(0, 0)
        getListCandidate(page - 1, searchText, sortBy, order)

        fetch(constants?.ListJobIdUrl, {
            headers: {
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            }
        })
            .then(res => res.json())
            .then(
                (result) => {
                    setJobPostId(result.data)
                })
        fetch(constants?.ListJobTitleUrl, {
            headers: {
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            }
        })
            .then(res => res.json())
            .then(
                (result) => {
                    setJobTitle(result.data)
                })
        fetch(constants?.ListCompanyNamesUrl, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            }
        })
            .then(res => res.json())
            .then(
                (result) => {
                    setJobCompanyName(result.data)
                })
        fetch(constants.ListCandidateQualificationsurl, {
            headers: {
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            }
        })
            .then(res => res.json())
            .then(
                (result) => {
                    setQualifications(result.data)
                })
        fetch(constants.ListStatusUrl, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            }
        })
            .then((res) => res.json())
            .then(
                (result) => {
                    setProgressList(result.data);
                })
        fetch(constants.ListAgentCodeUrl, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            }
        })
            .then((res) => res.json())
            .then(
                (result) => {
                    setAgentUniqueId(result.data);
                })

    }, [])

    function getListCandidate(page, search, sort, order) {
                let url = loggedInUser.roles === 'Recruitment Agent'
            ? `${constants.ListAppliedCandidatesByAgentUrl}/${loggedInUser.emailId}?page=${page}&search=${search || ''}&sortBy=${sort || ''}&sort=${order || ''}`
            : `${constants.ListCandidatesUrl}?page=${page}&search=${search || ''}&sortBy=${sort || ''}&sort=${order || ''}`
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            },
            body: JSON.stringify(filterData || {})
        })
            .then(res => res.json())
            .then(
                (result) => {
                    setIsLoaded(true);
                    setItems(result?.data?.content);
                    setPageDetails(result?.data)
                    setData(document.querySelectorAll('#application tbody tr'))
                },
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
    }
    //Filter 
    const handleFilter = () => {
        if (filterData)
            document.getElementById('staticBackdrop').style.display = "none"
        if (location?.pageCallBack) {
            getListCandidate(page - 1, searchText, sortBy, order)
        }
        else {
            setPage(1)
            getListCandidate(0, searchText, sortBy, order)
        }
    }

    const handleViewJob = (jobPostId) => {
        fetch(`${constants.GetJobByIdUrl}/${jobPostId}`, {
            headers: {
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            }
        })
            .then(res => res.json())
            .then((result) => {
                // console.log(result.data)
                setIsLoaded(true);
                //setItems(result.data);
                //setData(document.querySelectorAll('#application tbody tr'))
                history.push({
                    pathname: '/view-job',
                    state: result.data
                })
            },
                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
    }

    if (items) {
        candidateData = [...(items)];
    }

    const downloadResume = (candidate) => {
        // console.log("selected Row: ", candidate)
        if (candidate?.applyJobId) {
            var url = `${constants.DownloadResumeUrl}/${candidate?.applyJobId}`;
            // window.location.href = url;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser.sessionToken}`,
                },
            })
                .then(res => res.blob())
                .then(response => {
                    var fileDownload = require('js-file-download');
                    fileDownload(response, `${candidate?.cvFileName}`);
                })
        }
    }

    const handleRowClick = (selectedRow) => {
        //console.log("Job :" + selectedRow)
        history.push({
            pathname: '/view-candidate',
            state: selectedRow,
            filterDataCallback: filterData,
            searchCallBack: searchText,
            sortByCallBack: sortBy,
            orderCallBack: order,
            pageCallBack: page
        })
    }

    const handleSortOntable = (key, order) => {
        setSortBy(key)
        setOrder(order)
        if (location?.pageCallBack) {
            getListCandidate(page - 1, searchText, key, order)
        }
        else {
            setPage(1)
            getListCandidate(0, searchText, key, order)
        }
    }

    const handleEdit = (selectedRow) => {
        history.push({
            pathname: '/apply-job',
            state: selectedRow
        })
    } 
    const [deleteData, setDeleteData] = useState({});
    const handleDelete = (candidate) => {
        var url = `${constants.DeleteCandidateUrl}/${candidate.applyJobId}`;
        console.log(candidate);
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${loggedInUser.sessionToken}`,
            },
        })
            .then(res => res.json())
            .then((res) => {
                setDeleteData(res);
                console.log(res)
                toast.success(`✅ ${res.message.messageDescription} !`, {
                    position: 'top-right',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                  })
                  setTimeout(x=>{
                    window.location.reload();
                  },500)
              
              }).catch(error=>{
                console.log(error)
                toast.error(`❌ Please try after some time`, {
                    position: 'top-right',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                 })
              });

     
    }

    useEffect(() => {
        handleSearch(searchText);
    }, [searchText])

    const handleSearch = (search) => {
        if (location?.pageCallBack) {
            getListCandidate(page - 1, search || searchText, sortBy, order)
        }
        else {
            setPage(1)
            getListCandidate(0, search || searchText, sortBy, order)
        }
    }

    const [data, setData] = useState(
        document.querySelectorAll('#application tbody tr')
    )
    // console.log("data after finding value: " + data.length)

    // const sort = 20
    const activePag = useRef(0)
    const [test, settest] = useState(0)

    // Active data
    const chageData = (frist, sec) => {
        for (var i = 0; i < data.length; ++i) {
            if (i >= frist && i < sec) {
                data[i].classList.remove('d-none')
            } else {
                data[i].classList.add('d-none')
            }
        }
    }

    // use effect
    useEffect(() => {
        setData(document.querySelectorAll('#application tbody tr'))
        //chackboxFun()
    }, [test])

    const chackbox = document.querySelectorAll('.application_sorting_1 input')
    const motherChackBox = document.querySelector('#checkAll')

    const chackboxFun = (type) => {
        for (let i = 0; i < chackbox?.length; i++) {
            const element = chackbox[i]
            if (type === 'all') {
                if (motherChackBox.checked) {
                    element.checked = true
                } else {
                    element.checked = false
                }
            } else {
                if (!element.checked) {
                    motherChackBox.checked = false
                    break
                } else {
                    motherChackBox.checked = true
                }
            }
        }
    }
   

    return (
        <Fragment>
              <ToastContainer />
            <div className='d-flex flex-wrap mb-4'>
                <div className='mr-auto mb-2 pr-2 show-results'>
                    <h6 className='text-black fs-16 font-w600 mb-1'>
                        Showing {pageDetails?.totalElements} Candidates Results
                    </h6>
                    <span className='fs-14'>Based your preferences</span>
                </div>

                <div className="d-flex flex-wrap mb-l3 mb-s1">
                    <div className="input-group search-area d-xl-inline-flex">
                        <input type="text"
                            onChange={(e) =>
                                
                                {
                                    setSearchText(e.target.value)
                            console.log(e.target.value)
                                }
                            }
                            value={searchText}
                            className='form-control input-rounded mr-auto mb-md-0 mb-3'
                            placeholder="Search here..." />
                        <div className="input-group-append">
                            <span className="input-group-text"><i
                                className="flaticon-381-search-2"
                                onClick={handleSearch}
                                style={{ cursor: 'pointer' }} /></span>
                        </div>
                    </div>
                </div> &nbsp;&nbsp;
                {/* Filter */}
                <div className="d-flex flex-wrap mb-3">
                    <div>
                        <div className="dropdown custom-dropdown mb-0 mt-3 mt-sm-0 mb-1"  >
                            <button
                                className="btn btn-primary"
                                id="popupbox"
                                onClick={openFilter}
                                data-bs-toggle="modal"
                                data-bs-target="#staticBackdrop"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" class="bi bi-filter-square" viewBox="0 0 16 16"> <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" /> <path d="M6 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z" /> </svg> Filter
                            </button>
                            {/* popup */}
                            <div >
                                <div className="modal fade show" id="staticBackdrop"
                                    style={{ width: '550px', height: '63%', top: 100, left: 503 }}
                                    data-bs-backdrop="static"
                                    data-bs-keyboard="false"
                                    tabIndex="-1"
                                    aria-labelledby="staticBackdropLabel"
                                    aria-hidden="true">
                                    <div className="modal-dialog modal-lg" >
                                        <div className="modal-content" >
                                            <div className="" style={{ overflowY: "scroll", width: '550px', height: '250px' }}>
                                                <div>
                                                    {/* className="modal-header" */}
                                                    <Col lg={12}>
                                                        <Card>
                                                            <Card.Body>
                                                                <h4><b>Filter Job</b></h4>
                                                                <br></br>
                                                                {/* firstcolumn  */}
                                                                <div className="row">
                                                                    <div className="col-xl-6">
                                                                       <div form-group row>
                                                                       { loggedInUser.roles  != 'Recruitment Agent' ?<ReactMultiSelectCheckboxes
                                                                                placeholderButtonLabel="Company Name"
                                                                                isMulti
                                                                                options={companyNameOptions()}
                                                                                onChange={value => {
                                                                                    handleCompanyName(value);
                                                                                }}
                                                                            /> :''}
                                                                        </div>  { loggedInUser.roles  != 'Recruitment Agent' ?<br></br> :'' }
                                                                        <div form-group row>
                                                                            <ReactMultiSelectCheckboxes
                                                                                placeholderButtonLabel="Qualification"
                                                                                isMulti
                                                                                options={qualificationOptions()}
                                                                                // value={qualificationselectedOptions}
                                                                                // setState={setQualificationselectedOptions}
                                                                                // onChange={
                                                                                //     handleQualifications
                                                                                // }
                                                                                onChange={value => {
                                                                                    handleQualifications(value);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <br></br>
                                                                        <div form-group row>
                                                                            <ReactMultiSelectCheckboxes
                                                                                placeholderButtonLabel="Status"
                                                                                isMulti
                                                                                options={statusOptions()}
                                                                                onChange={value => {
                                                                                    handleListStatus(value);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <br></br>
                                                                        <div form-group row>
                                                                            <ReactMultiSelectCheckboxes
                                                                                placeholderButtonLabel="Agent Code"
                                                                                isMulti
                                                                                options={agentCodeOptions()}
                                                                                onChange={value => {
                                                                                    handleAgentCode(value);
                                                                                }}
                                                                            />
                                                                        </div>

                                                                    </div>
                                                                    {/* 2ndcolumn */}
                                                                    <div className="col-xl-6">
                                                                        <div form-group row>
                                                                            <ReactMultiSelectCheckboxes
                                                                                placeholderButtonLabel="Job Id"
                                                                                isMulti
                                                                                options={jobIdOptions()}
                                                                                onChange={value => {
                                                                                    handleJobId(value);
                                                                                }}
                                                                            />
                                                                        </div><br></br>
                                                                        <div form-group row>
                                                                            <ReactMultiSelectCheckboxes
                                                                                placeholderButtonLabel="Ready To Relocate"
                                                                                isMulti
                                                                                options={readyToRelocateOptions()}
                                                                                onChange={value => {
                                                                                    handleReadyToRelocate(value);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <br></br>


                                                                    
                                                                     

                                                                        <div form-group row>
                                                                            <ReactMultiSelectCheckboxes
                                                                                placeholderButtonLabel="Job Title"
                                                                                isMulti
                                                                                options={jobTitleOptions()}
                                                                                onChange={value => {
                                                                                    handleJobTitle(value);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <br></br>
                                                                        <div align="">
                                                                            <button type="button" onClick={clearFilter} className="btn btn-primary">Clear</button>&nbsp;&nbsp;
                                                                            <button type="button" onClick={handleFilter} className="btn btn-primary">Apply</button>&nbsp;&nbsp;
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>&nbsp;&nbsp;
                {/* <div className="d-flex flex-wrap mb-3">
                    <DropdownButton
                        id="dropdown-basic-button"
                        variant="primary"
                        className="dropdown custom-dropdown mb-0 mr-4 mt-3 mt-sm-0 mb-1"
                        onSelect={handleSorting}
                        title={sorting?.key || "Sort By"}
                        style={{ color: '#00ADEE' }}
                    >
                        {sortList.map((item, index) => {
                            return (
                                <Dropdown.Item key={index} eventKey={item?.value} onClick={() => { handleSort(item?.key) }}>
                                    {item?.value}
                                </Dropdown.Item>
                            );
                        })}
                    </DropdownButton>
                </div> */}
            </div>
            <div className='row'>
                <div className='col-xl-12'>
                    <div className='table-responsive'>
                        <div id='application' className='dataTables_wrapper no-footer'>
                            {!isLoaded
                                ? <div>
                                    <Box className='card' sx={{ width: '100%' }}>
                                        <LinearProgress />
                                    </Box>
                                </div>
                                : !items || candidateData?.length <= 0 ? <div>No records found</div>
                                    : <table
                                        className='table display mb-4 dataTablesCard table-responsive-xl card-table dataTable no-footer'
                                        id='example5'
                                    >
                                        <thead>
                                            <tr role='row'>
                                                <th className='sorting' style={{ width: '100px', border: 'none' }}>
                                                    <div class="row" style={{ flexWrap: 'unset', justifyContent: 'center' }}>
                                                        <span textAlign='center'>Name</span>
                                                        <div className='alignCenter' style={{ display: 'flex', flexDirection: 'column', width: '20px', marginLeft: '10px', alignItems: 'flex-start' }}>
                                                            <i class='fa fa-sort-asc ' style={{
                                                                padding: '0px',
                                                                height: '8px',
                                                                marginTop: '3px',
                                                            }} type='button' onClick={
                                                                () => {
                                                                    handleSortOntable("candidateName", 'asc')
                                                                }
                                                            }></i>
                                                            <i class='fa fa-sort-desc' style={{ height: '8px', marginTop: '-3px' }} type='button' onClick={() => { handleSortOntable("candidateName", 'desc') }}></i></div></div></th>
                                                <th className='sorting'>Email_Id</th>
                                                <th className='sorting'>Mobile Number</th>
                                                <th className='sorting' style={{ width: '100px', border: 'none' }}>
                                                    <div class="row" style={{ flexWrap: 'unset' }}>
                                                        <span>Qualification</span>
                                                        <div className='alignCenter' style={{ display: 'flex', flexDirection: 'column', width: '20px', marginLeft: '10px', alignItems: 'flex-start' }}>
                                                            <i class='fa fa-sort-asc ' style={{
                                                                padding: '0px',
                                                                height: '8px',
                                                                marginTop: '3px',
                                                            }} type='button' onClick={
                                                                () => {
                                                                    handleSortOntable("qualification", 'asc')
                                                                }
                                                            }></i>
                                                            <i class='fa fa-sort-desc' style={{ height: '8px', marginTop: '-3px' }} type='button' onClick={() => { handleSortOntable("qualification", 'desc') }}></i></div></div></th>
                                                <th className='sorting' style={{ width: '100px', border: 'none' }}>
                                                    <div class="row" style={{ flexWrap: 'unset' }}>
                                                        <span>Experience</span>
                                                        <div className='alignCenter' style={{ display: 'flex', flexDirection: 'column', width: '20px', marginLeft: '10px', alignItems: 'flex-start' }}>
                                                            <i class='fa fa-sort-asc ' style={{
                                                                padding: '0px',
                                                                height: '8px',
                                                                marginTop: '3px',
                                                            }} type='button' onClick={
                                                                () => {
                                                                    handleSortOntable("experienceInYears", 'asc')
                                                                }
                                                            }></i>
                                                            <i class='fa fa-sort-desc' style={{ height: '8px', marginTop: '-3px' }} type='button' onClick={() => { handleSortOntable("experienceInYears", 'desc') }}></i></div></div></th>
                                                <th className='sorting' style={{ width: '100px', border: 'none' }}>
                                                    <div class="row" style={{ flexWrap: 'unset' }}>
                                                        <span>Current CTC </span>
                                                        <div className='alignCenter' style={{ display: 'flex', flexDirection: 'column', width: '20px', marginLeft: '10px', alignItems: 'flex-start' }}>
                                                            <i class='fa fa-sort-asc ' style={{
                                                                padding: '0px',
                                                                height: '8px',
                                                                marginTop: '3px',
                                                            }} type='button' onClick={
                                                                () => {
                                                                    handleSortOntable("currentCtc", 'asc')
                                                                }
                                                            }></i>
                                                            <i class='fa fa-sort-desc' style={{ height: '8px', marginTop: '-3px' }} type='button' onClick={() => { handleSortOntable("currentCtc", 'desc') }}></i></div></div></th>
                                                <th className='sorting' style={{ width: '100px', border: 'none' }}>
                                                    <div class="row" style={{ flexWrap: 'unset' }}>
                                                        <span>Job Id</span>
                                                        <div className='alignCenter' style={{ display: 'flex', flexDirection: 'column', width: '20px', marginLeft: '10px', alignItems: 'flex-start' }}>
                                                            <i class='fa fa-sort-asc ' style={{
                                                                padding: '0px',
                                                                height: '8px',
                                                                marginTop: '3px',
                                                            }} type='button' onClick={
                                                                () => {
                                                                    handleSortOntable("jobPostId", 'asc')
                                                                }
                                                            }></i>
                                                            <i class='fa fa-sort-desc' style={{ height: '8px', marginTop: '-3px' }} type='button' onClick={() => { handleSortOntable("jobPostId", 'desc') }}></i></div></div></th>
                                                <th className='sorting' style={{ width: '100px', border: 'none' }}>
                                                    <div class="row" style={{ flexWrap: 'unset' }}>
                                                        <span>Job Title</span>
                                                        <div className='alignCenter' style={{ display: 'flex', flexDirection: 'column', width: '20px', marginLeft: '10px', alignItems: 'flex-start' }}>
                                                            <i class='fa fa-sort-asc ' style={{
                                                                padding: '0px',
                                                                height: '8px',
                                                                marginTop: '3px',
                                                            }} type='button' onClick={
                                                                () => {
                                                                    handleSortOntable("jobTitle", 'asc')
                                                                }
                                                            }></i>
                                                            <i class='fa fa-sort-desc' style={{ height: '8px', marginTop: '-3px' }} type='button' onClick={() => { handleSortOntable("jobTitle", 'desc') }}></i></div></div></th>
                                                            { loggedInUser.roles  != 'Recruitment Agent' ?   <th className='sorting' style={{ width: '100px', border: 'none' }}>
                                                    <div class="row" style={{ flexWrap: 'unset' }}>
                                                        <span>Company Name</span>
                                                        <div className='alignCenter' style={{ display: 'flex', flexDirection: 'column', width: '20px', marginLeft: '10px', alignItems: 'flex-start' }}>
                                                            <i class='fa fa-sort-asc ' style={{
                                                                padding: '0px',
                                                                height: '8px',
                                                                marginTop: '3px',
                                                            }} type='button' onClick={
                                                                () => {
                                                                    handleSortOntable("jobCompanyName", 'asc')
                                                                }
                                                            }></i>
                                                            <i class='fa fa-sort-desc' style={{ height: '8px', marginTop: '-3px' }} type='button' onClick={() => { handleSortOntable("jobCompanyName", 'desc') }}></i></div></div></th>
                                                    :''}
                                                <th className='sorting' style={{ width: '100px', border: 'none' }}>
                                                    <div class="row" style={{ flexWrap: 'unset' }}>
                                                        <span>Status</span>
                                                        <div className='alignCenter' style={{ display: 'flex', flexDirection: 'column', width: '20px', marginLeft: '10px', alignItems: 'flex-start' }}>
                                                            <i class='fa fa-sort-asc ' style={{
                                                                padding: '0px',
                                                                height: '8px',
                                                                marginTop: '3px',
                                                            }} type='button' onClick={
                                                                () => {
                                                                    handleSortOntable("status", 'asc')
                                                                }
                                                            }></i>
                                                            <i class='fa fa-sort-desc' style={{ height: '8px', marginTop: '-3px' }} type='button' onClick={() => { handleSortOntable("status", 'desc') }}></i></div></div></th>
                                                {loggedInUser.roles === 'Admin' &&
                                                    <th className='sorting' style={{ width: '100px', border: 'none' }}>
                                                        <div class="row" style={{ flexWrap: 'unset' }}>
                                                            <span>Agent Code</span>
                                                            <div className='alignCenter' style={{ display: 'flex', flexDirection: 'column', width: '20px', marginLeft: '10px', alignItems: 'flex-start' }}>
                                                                <i class='fa fa-sort-asc ' style={{
                                                                    padding: '0px',
                                                                    height: '8px',
                                                                    marginTop: '3px',
                                                                }} type='button' onClick={
                                                                    () => {
                                                                        handleSortOntable("agentUniqueId", 'asc')
                                                                    }
                                                                }></i>
                                                                <i class='fa fa-sort-desc' style={{ height: '8px', marginTop: '-3px' }} type='button' onClick={() => { handleSortOntable("agentUniqueId", 'desc') }}></i></div></div></th>
                                                }
                                                  <th className='sorting'>Date</th>
                                                <th className='sorting'>Resume</th>
                                                {loggedInUser.roles === 'Admin' &&
                                                    <th className='sorting'>Action</th>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {candidateData?.map((candidate) =>
                                            (<tr role='row' style={{ cursor: 'pointer' }} className='odd ' >
                                                <td className='text-truncate left-Column-align '>
                                               { loggedInUser.roles  != 'Recruitment Agent'?  <Link style={{ color: '#00ADEE', padding: '2px' }}
                                                        to={{
                                                            pathname: "/apply-job",
                                                            state: candidate
                                                        }}
                                                    >
                                                        <i className='fa fa-edit mr-1' />
                                                    </Link>:''}
                                                    <span onClick={() => handleRowClick(candidate)}>{candidate.candidateName}</span> </td>
                                                <td onClick={() => handleRowClick(candidate)}>{candidate.emailId}</td>
                                                <td onClick={() => handleRowClick(candidate)}>{candidate.mobile}</td>
                                                <td onClick={() => handleRowClick(candidate)}>{candidate.qualification}</td>
                                                <td onClick={() => handleRowClick(candidate)}>{candidate.experienceInYears}</td>
                                                <td onClick={() => handleRowClick(candidate)}>{candidate.currentCtc} LPA</td>
                                                <td>
                                                    <button style={{ border: 'none',padding: '5px 10px', backgroundColor: '#00ADEE', textAlign: 'center' }}
                                                        type="button"
                                                        className="btn btn-primary btn-sm"
                                                        onClick={() => handleViewJob(candidate.jobPostId)}
                                                    > {candidate.jobPostId}
                                                    </button>
                                                </td>
                                                <td onClick={() => handleRowClick(candidate)}>{candidate.jobTitle}</td>
                                                { loggedInUser.roles  != 'Recruitment Agent' ?   <td onClick={() => handleRowClick(candidate)}>{candidate.jobCompanyName}</td>:''}


                                                  <td onClick={() => handleRowClick(candidate)}>{candidate.status}</td>

                                                {loggedInUser.roles  != 'Recruitment Agent'  ?
                                                    <td onClick={() => handleRowClick(candidate)}>{candidate.agentUniqueId}</td>:''
                                                }
                                                <td onClick={() => handleRowClick(candidate)}>{new Date(candidate.createdDate).toLocaleDateString()}</td>
                                                <td>
                                                    <div>
                                                        <button style={{ border: 'none',padding: '5px 10px', backgroundColor: '#00ADEE', textAlign: 'center' }}
                                                            type="submit"
                                                            className="btn btn-primary btn-sm"
                                                            onClick={() => downloadResume(candidate)}
                                                        >
                                                            {/* <i className='fa fa-edit mr-2' /> */}
                                                            Download
                                                        </button>
                                                    </div>
                                                </td>

                                                {loggedInUser.roles === 'Admin' &&
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            <Dropdown className='dropdown float-right custom-dropdown mb-0'>
                                                                <Dropdown.Toggle
                                                                    className='i-false'
                                                                    data-toggle='dropdown'
                                                                    variant=''
                                                                >
                                                                    <svg
                                                                        width={24}
                                                                        height={24}
                                                                        viewBox='0 0 24 24'
                                                                        fill='none'
                                                                        xmlns='http://www.w3.org/2000/svg'
                                                                    >
                                                                        <path
                                                                            d='M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z'
                                                                            stroke='#2E2E2E'
                                                                            strokeWidth={2}
                                                                            strokeLinecap='round'
                                                                            strokeLinejoin='round'
                                                                        />
                                                                        <path
                                                                            d='M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z'
                                                                            stroke='#2E2E2E'
                                                                            strokeWidth={2}
                                                                            strokeLinecap='round'
                                                                            strokeLinejoin='round'
                                                                        />
                                                                        <path
                                                                            d='M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z'
                                                                            stroke='#2E2E2E'
                                                                            strokeWidth={2}
                                                                            strokeLinecap='round'
                                                                            strokeLinejoin='round'
                                                                        />
                                                                    </svg>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className='dropdown-menu dropdown-menu-right'>
                                                                    <Dropdown.Item className='dropdown-item' onClick={() => handleEdit(candidate)}>
                                                                        Edit
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item className='dropdown-item'
                                                                      onClick={() => handleDelete(candidate)}
                                                                     >
                                                                        Delete
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item className='dropdown-item text-danger'>
                                                                        Cancel
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                }

                                            </tr>
                                            )
                                            )}
                                        </tbody>
                                    </table>
                            }
                            <div className='d-sm-flex text-center justify-content-between align-items-center'>
                                <div className='dataTables_info' id='example5_info'>
                                    Page: {page}
                                </div>
                                <div>
                                    <Pagination count={pageDetails?.totalPages} page={page} onChange={handlePageChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment >
    )
}

export default ListCandidate